<template>
  <div>
    <slot></slot>
  </div>
</template>

<style scoped>
div {
  margin: 2rem auto;
  padding: 1rem;
  border-radius: 12px;
}
</style>